import { useCallback, useMemo } from "react";
var useViewTypes = function () {
    var onClickTypeView = useCallback(function (option, setPage, setCertificateTrigger) {
        switch (option.name) {
            case "GridView":
                setPage(1);
                setCertificateTrigger(true);
                break;
            case "List":
                setPage(1);
                setCertificateTrigger(true);
                break;
            case "tableView":
                setPage(1);
                setCertificateTrigger(true);
        }
    }, []);
    return useMemo(function () { return ({
        onClickTypeView: onClickTypeView,
    }); }, [onClickTypeView]);
};
export default useViewTypes;
